const getCompanyLogo = (rootState) =>
  rootState.ws.integration.settings.branding &&
  rootState.ws.integration.settings.branding.companyLogo;

export default getCompanyLogo;
